import { CourseType } from '../../../types'
import { getCourseLessons } from '.'

export const getCourseLessonCount = (course?: CourseType) => {
  if (!course) {
    return 0
  }

  const allLessons = getCourseLessons(course)
  return allLessons.length
}
